<template>
  <HeraConfirm
    v-bind="{
      title: isLoading
        ? ''
        : $t(
            '_web_tournaments_management_player_registration_modal_title',
            `{username}'s application form`,
            {
              username,
            }
          ),
      cancelButtonText: $t(
        '_web_tournaments_management_player_registration_modal_back_button',
        'Back'
      ),
      confirmButtonText: false,
      isLoading,
    }"
    :class="{
      'loading-data': isLoading,
    }"
    class="application-form-modal"
    v-on="$listeners"
  >
    <template v-if="isLoading">
      <HeraDummyList
        size="150"
        icon-name="dummy/members"
        :text="$t('_web_loading', 'Loading...')"
      />
    </template>
    <template v-else>
      <PanelRow
        v-for="(cols, index) in rows"
        :key="`${index}-${cols.length}`"
        :items="cols"
        class="text-left"
      />
    </template>
  </HeraConfirm>
</template>

<script>
import loadingMixin from '@/mixins/isLoading';
import { mapActions } from 'vuex';
import HeraConfirm from '@/components/modal/children/HeraConfirm';
import PanelRow from '@/views/account/content/PanelRow';
import HeraDummyList from '@/components/common/HeraDummyList';
import { propRequired } from '@/utils/factories';
import { translate } from '@/mixins/translate';
const DEFAULT_FIELDS = [
  'applicationDate',
  'applicationTime',
  'approvedTo',
  'attributes',
  'avatar',
  'checked_in',
  'username',
  'user',
];
export default {
  name: 'PlayersRegistrationDataModal',
  components: {
    HeraConfirm,
    PanelRow,
    HeraDummyList,
  },
  mixins: [translate('_web_tournament_players_row'), loadingMixin],
  props: {
    playerId: propRequired(String),
  },
  data() {
    return {
      userData: {},
    };
  },
  computed: {
    username() {
      return this.userData.fields_data && this.userData.fields_data.user
        ? this.userData.fields_data.user.login ||
            this.userData.fields_data.user.name
        : 'Participant';
    },
    rows() {
      return this.$lodash.isEmpty(this.userData)
        ? []
        : [
            [
              this.getFormatedCol(
                this.$t(
                  `_web_participants-list_column-applicationDate`,
                  this.$filters.startCase('applicationDate')
                ),
                this.$filters.localDate(
                  this.userData.fields_data['applicationDate'],
                  this.$times.DATE_SHORT
                ),
                6
              ),
              this.getFormatedCol(
                this.$t(
                  `_web_participants-list_column-applicationTime`,
                  this.$filters.startCase('applicationTime')
                ),
                this.$filters.localDate(
                  this.userData.fields_data['applicationTime'],
                  this.$times.TIME_SIMPLE
                ),
                6
              ),
            ],
            ...Object.keys(this.userData.fields_data)
              .filter(key => !DEFAULT_FIELDS.includes(key))
              .map(key => [
                this.getFormatedCol(
                  this.$t(
                    `_web_participants-list_column-${key}`,
                    this.$filters.startCase(key)
                  ),
                  this.userData.fields_data[key]
                ),
              ]),
          ];
    },
  },
  created() {
    this.setLoading();
    this.fetchTournamentPlayers({
      id: this.$route.params.tournamentID,
      query: {
        player_ids: [this.playerId],
        page_size: 1,
        page_number: 0,
      },
    })
      .then(response => {
        if (!this.$lodash.isEmpty(response.items)) {
          this.userData = response.items[0];
        }
      })
      .catch(this.errorNotify)
      .finally(this.unsetLoading);
  },
  methods: {
    ...mapActions(['fetchTournamentPlayers', 'errorNotify']),
    getFormatedCol(
      title = null,
      description = null,
      colWidth = 0,
      slotName = null
    ) {
      return {
        title,
        description,
        colWidth,
        slotName,
      };
    },
  },
};
</script>
<style lang="scss">
.application-form-modal {
  .container-dummy {
    min-height: 200px;
  }
}
</style>
